import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

// Shared Firebase project — same as UX-OKR-Tracker + Rascal Kanban
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);

// ─── e2e seam: Firebase emulators ──────────────────────────────────
// When `VITE_USE_FIREBASE_EMULATORS=1` is set (only the Playwright
// suite does this), route Auth + Firestore at the local emulator
// instead of staging. Keeps the smoke pass off real infra.
// See playwright.config.ts and e2e/global-setup.ts.
if (import.meta.env.VITE_USE_FIREBASE_EMULATORS === '1') {
  const authHost = import.meta.env.VITE_AUTH_EMULATOR_HOST || 'http://127.0.0.1:9099';
  const fsHost   = import.meta.env.VITE_FIRESTORE_EMULATOR_HOST || '127.0.0.1:8080';
  const [fsHostname, fsPort] = fsHost.split(':');
  connectAuthEmulator(auth, authHost, { disableWarnings: true });
  connectFirestoreEmulator(db, fsHostname, parseInt(fsPort, 10));
}

export default app;
